module.exports = __webpack_public_path__ + "assets/bug.f34b1328.svg";